module.exports = __webpack_public_path__ + "static/media/resource.523853e7.png";